import React, { Component } from 'react';
import globalURL from 'helper/url';
import DarkSquareBorderButton from '@lyearn-team/frontend-components/dist/Button/DarkSquareBorderButton';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import { LoginTypesWrapper, SocialButtonWrapper, signInWithSAML } from './styles';
import { getDarkGoogleTemplate, getSprinklrTemplate } from '../../shared/static';
import SamlLogin from '../SamlLogin';

export default class DarkLoginWrapper extends Component {
  state = {
    samlPopupVisible: false
  };

  onGoogleLogin = e => {
    e.preventDefault();
    this.redirectForLoginMode('google');
  };

  onSprinklrLogin = () => {
    this.redirectForLoginMode('sprinklrsso');
  };

  onOktaLogin = () => {
    this.redirectForLoginMode('okta');
  };

  onSAMLLogin = () => {
    if (this.props.companyInfo.twoWaySAMLLogin) {
      this.setState({
        samlPopupVisible: true
      });
    } else {
      this.redirectForLoginMode('saml');
    }
  };

  getLoginButton = (type, index, flexDirection) => {
    let marginLeftAuto = false;
    if (index >= 1 && flexDirection === 'row') {
      marginLeftAuto = true;
    }
    switch (type) {
      case 'GOOGLE_LOGIN':
        return (
          <SocialButtonWrapper
            key="GOOGLE_LOGIN"
            onClick={this.onGoogleLogin}
            dangerouslySetInnerHTML={{ __html: getDarkGoogleTemplate('signin') }}
          />
        );
      case 'SPRINKLR_LOGIN':
        return (
          <SocialButtonWrapper
            key="SPRINKLR_LOGIN"
            onClick={this.onSprinklrLogin}
            dangerouslySetInnerHTML={{ __html: getSprinklrTemplate('signin') }}
          />
        );
      case 'OKTA':
        return (
          <DarkSquareBorderButton
            key="OKTA"
            onClick={this.onOktaLogin}
            // dangerouslySetInnerHTML={{ __html: getOktaTemplate('signin') }}
          >
            OKTA
          </DarkSquareBorderButton>
        );
      case 'SAML_LOGIN':
        if (
          !this.props.companyInfo.companyLoginInfo.SAMLData ||
          !this.props.companyInfo.companyLoginInfo.SAMLData.SPInitiated
        ) {
          return null;
        }
        return (
          <DarkButton.SecondaryButton
            key="SAML_LOGIN"
            onClick={this.onSAMLLogin}
            className={signInWithSAML(marginLeftAuto)}
          >
            {this.props.companyInfo.companyLoginInfo.SAMLData.samlProviderName}
          </DarkButton.SecondaryButton>
        );
      default:
        return true;
    }
  };

  onSAMLPopupClosed = () => {
    this.setState({
      samlPopupVisible: false
    });
  };

  redirectForLoginMode = (loginMode, options = {}) => {
    const awsEndpoint = globalURL.awsEndpoint;
    const redirectURL = window.location.host + '/#/login-redirect';
    let loginRedirectURL =
      awsEndpoint +
      '/testglogin?redirectHost=' +
      encodeURIComponent(redirectURL) +
      '&subdomain=' +
      this.props.companyInfo.subDomain +
      '&device=web&loginMode=' +
      loginMode;
    if (options.partnerEnvironment) {
      loginRedirectURL = `${loginRedirectURL}&partnerEnvironment=${options.partnerEnvironment}&redirectionDomain=${options.redirectionDomain}&useNewAPI=true`;
    }
    window.location.href = loginRedirectURL;
  };

  render() {
    const { loginTypes } = this.props;
    const upperLimitForFlex = loginTypes.indexOf('EMAIL_LOGIN') > -1 ? 3 : 2;
    const flexDirection = loginTypes.length > upperLimitForFlex ? 'column' : 'row';
    return (
      <React.Fragment>
        <LoginTypesWrapper flexDirection={flexDirection}>
          {loginTypes.map((type, index) => this.getLoginButton(type, index, flexDirection))}
        </LoginTypesWrapper>
        {this.state.samlPopupVisible ? (
          <SamlLogin
            showPopup={this.state.samlPopupVisible}
            onPopuoClose={this.onSAMLPopupClosed}
            companyInfo={this.props.companyInfo}
            redirect={this.redirectForLoginMode}
          />
        ) : null}
      </React.Fragment>
    );
  }
}
